import { createStore } from 'vuex';
import main from '@/store/main';


// Создание хранилища Vuex с использованием модуля "main"
const storetranscrib = new createStore({
  modules: {
    main: main,
  },
  state: {
    testData: 'Test data for store2',
  },
  mutations: {
    SET_TEST_DATA(state, data) {
      state.testData = data;
    },
  },
  actions: {
    setTestData2({ commit }, data) {
      commit('SET_TEST_DATA', data);
    },
  },
  getters: {
    getTestData2: state => state.testData,
  },
});

export default storetranscrib;
